import { IssueDetailData } from '@/entities/issue/public';

export type IssueStatusType = Pick<IssueDetailData, 'status'>;

export const emptyIssue = (): IssueDetailData => {
  return {
    id: 0,
    title: '',
    description: '',
    associateAssignees: [],
    status: 0,
    entityItem: null,
    priority: 0,
    suggestedCorrectiveAction: '',
    performedCorrectiveAction: '',
    deadline: null,
    photos: [],
    sensorsLastMeasurement: '',
    locale: '',
  };
};
